// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__Rmwfa","employee-header-item":"Header_employee-header-item__NPeyH"};